export default "__VITE_ASSET__BtW8Ip2w__"